// ══════════════════════════════════════════════════════════════════════════════
// PWA KURULUM İSTEMİ — TEK KAYNAK (partner panelindeki pwaInstall.ts'in eşi)
//
// Tarayıcı `beforeinstallprompt` olayını sayfa yüklenirken BİR KEZ yayınlar. Olay
// React bileşeni mount olmadan düşerse ve dinleyici bileşenin içindeyse olay KAYBOLUR
// ("kurulum penceresi bazen çıkıyor bazen çıkmıyor" sebebi). Bu modül import edildiği
// anda dinleyiciyi kurar ve olayı saklar; arayüz olayı beklemez, buradan SORAR.
// ══════════════════════════════════════════════════════════════════════════════

const DISMISS_KEY = 'fleet-pwa-install-dismissed-at';
/** "Daha sonra" sonsuza kadar susturmaz: bu süre geçince davet bir kez daha çıkar. */
const REMIND_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

let deferredPrompt = null;
let installed = false;
const subs = new Set();

export function isStandalone() {
    if (typeof window === 'undefined') return false;
    return window.matchMedia?.('(display-mode: standalone)').matches
        || window.navigator?.standalone === true;
}

function currentState() {
    return { available: !!deferredPrompt, installed: installed || isStandalone() };
}

function publish() {
    const state = currentState();
    subs.forEach((cb) => { try { cb(state); } catch { /* yut */ } });
}

if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();          // tarayıcının kendi çubuğu yerine BİZ soruyoruz
        deferredPrompt = e;
        publish();
    });
    window.addEventListener('appinstalled', () => {
        deferredPrompt = null;
        installed = true;
        publish();
    });
}

export function subscribeInstallState(cb) {
    subs.add(cb);
    cb(currentState());
    return () => { subs.delete(cb); };
}

export function getInstallState() {
    return currentState();
}

/** @returns 'accepted' | 'dismissed' | 'unavailable' */
export async function promptInstall() {
    if (!deferredPrompt) return 'unavailable';
    try {
        deferredPrompt.prompt();
        const res = await deferredPrompt.userChoice;
        deferredPrompt = null;
        publish();
        return res?.outcome === 'accepted' ? 'accepted' : 'dismissed';
    } catch {
        deferredPrompt = null;
        publish();
        return 'dismissed';
    }
}

export function snoozeInstallCard() {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* yut */ }
}

export function canShowInstallCard() {
    try {
        const raw = localStorage.getItem(DISMISS_KEY);
        if (!raw) return true;
        const at = Number(raw);
        if (!Number.isFinite(at)) return true;
        return Date.now() - at > REMIND_AFTER_MS;
    } catch {
        return true;
    }
}
